<template>
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13 20C13 22.2091 11.2091 24 9 24C6.79086 24 5 22.2091 5 20C5 17.7909 6.79086 16 9 16C11.2091 16 13 17.7909 13 20Z"
      class="fill-current"
    />
    <path
      d="M24 20C24 22.2091 22.2091 24 20 24C17.7909 24 16 22.2091 16 20C16 17.7909 17.7909 16 20 16C22.2091 16 24 17.7909 24 20Z"
      class="fill-current"
    />
    <path
      d="M35 20C35 22.2091 33.2091 24 31 24C28.7909 24 27 22.2091 27 20C27 17.7909 28.7909 16 31 16C33.2091 16 35 17.7909 35 20Z"
      class="fill-current"
    />
  </svg>
</template>
